// extracted by mini-css-extract-plugin
export default {"no-animation-fill":"HealthSystem_no-animation-fill__9siAi"};